import React from "react";

export default function Hero() {
  return (
    <header className="App-header">
      <div className="hero">
        <div className="title-container">
          <h1 className="title">Lilly Golden Editorial</h1>
          <h2 className="subtitle">editor │ writer │ collaborator</h2>
        </div>
      </div>
    </header>
  );
}
